const indexItems = [
  { title: '韩漫热榜', desc: '最受欢迎的韩漫全集排行', icon: 'ri-fire-line', color: 'accent' },
  { title: '日漫经典', desc: '日漫全集经典作品合集', icon: 'ri-sun-line', color: 'primary' },
  { title: '国漫精选', desc: '优秀国漫连载与全集', icon: 'ri-flag-2-line', color: 'secondary' },
  { title: '恋爱甜宠', desc: '甜到心里的恋爱漫画', icon: 'ri-heart-line', color: 'accent' },
  { title: '奇幻冒险', desc: '异世界与魔法冒险之旅', icon: 'ri-compass-3-line', color: 'primary' },
  { title: '悬疑推理', desc: '烧脑剧情反转不断', icon: 'ri-search-eye-line', color: 'secondary' },
  { title: '都市生活', desc: '现代都市百态人生', icon: 'ri-building-line', color: 'accent' },
  { title: '热血战斗', desc: '燃爆全场的战斗漫画', icon: 'ri-sword-line', color: 'primary' },
  { title: '搞笑日常', desc: '轻松一笑的欢乐漫画', icon: 'ri-emotion-laugh-line', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; icon: string; border: string }> = {
  accent: { bg: 'bg-accent-100', icon: 'text-accent-600', border: 'hover:border-accent-300' },
  primary: { bg: 'bg-primary-100', icon: 'text-primary-600', border: 'hover:border-primary-300' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-600', border: 'hover:border-secondary-300' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            分类索引
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            漫画索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            按品类与题材快速定位，在布丁漫画网找到你喜欢的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.title}
                className={`flex items-center gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 ${c.border} transition-all duration-200 cursor-default`}
              >
                <div className={`w-12 h-12 rounded-xl ${c.bg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} text-xl ${c.icon}`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 mt-0.5">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}